import React from "react";

import OpenSvg from "../../assets/images/icons/open_reverse.svg";

export const OpenReverseIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={OpenSvg}
        alt={alt || "Open"}
    />
);
